<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-licenca') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="licencasSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="empresas"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="licencasSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idlicenca === linha.idlicenca"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                        <div v-if="f.key == 'status'">
                            {{$t( props.row['status'] == 1 ? "ativo" : "inativo")}}
                        </div>
                        <div v-else-if="f.key == 'bloqueiavenda'">
                            {{$t( props.row['bloqueiavenda'] == 1 ? "sim" : "nao")}}
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>

                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssProdutoLicencaService from "@/services/vendas/produto/AssProdutoLicencaService";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idProduto: 0,
    },
    data() {
        return {
            service: new AssProdutoLicencaService(this.$http, this.$router),
            empresas: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                {key: 'descricao', width: null, sortable: true, sortFn: null},
                {key: 'status', width: null, sortable: true, sortFn: null},
                {key: 'bloqueiavenda', width: null, sortable: true, sortFn: null},
            ],
            licencasSelecionados: [],
            idproduto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            this.service
            .findLicencasNaoAssociadosProduto(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idProduto,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.empresas = value;
                this.isEmpty = this.empresas.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },

        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idlicenca: m.idlicenca,
                    replicapda: m.replicapda,
                    descricao: m.descricao,
                    status: m.status,
                    bloqueiavenda: m.bloqueiavenda,
                };
            });
        },
        mapOnSave(itens) {
            return itens.map(m => {
                return {
                    idproduto: this.idProduto,
                    idlicenca: m.idlicenca,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.licencasSelecionados.length > 0) {
                this.isLoading = true;
                
                this.service.save(this.mapOnSave(this.licencasSelecionados))
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-usuario', true));
                this.isLoading = false;
            }
        },
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>